import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './AppIcon';
import { useSubscription, FEATURE_LABELS } from '../context/SubscriptionContext';

const FeatureLockedPage = ({ featureKey, featureLabel }) => {
  const navigate = useNavigate();
  const { planName, subscription } = useSubscription();

  const label = featureLabel || FEATURE_LABELS[featureKey] || 'This feature';

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-lg w-full bg-card border border-border rounded-2xl p-8 text-center shadow-lg">
        {/* Lock icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-amber-100 to-orange-100 rounded-2xl flex items-center justify-center">
          <Icon name="Lock" size={36} className="text-amber-600" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-foreground mb-2">
          {label} is Locked
        </h2>

        {/* Description */}
        <p className="text-muted-foreground mb-6">
          This feature is not included in your current <span className="font-semibold capitalize text-foreground">{planName}</span> plan. 
          Please contact your administrator to upgrade your subscription and unlock this feature.
        </p>

        {/* Plan badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-surface rounded-lg border border-border mb-6">
          <Icon name="CreditCard" size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">Current plan:</span>
          <span className="text-sm font-bold capitalize text-foreground">{planName}</span>
        </div>

        {/* Available features hint */}
        <div className="bg-gradient-to-r from-blue-50 to-emerald-50 rounded-xl p-4 mb-6 text-left">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Crown" size={16} className="text-blue-600" />
            <span className="text-sm font-semibold text-blue-900">Enterprise plan includes:</span>
          </div>
          <ul className="space-y-1.5 text-sm text-blue-800">
            <li className="flex items-center gap-2">
              <Icon name="Check" size={14} className="text-emerald-600" />
              Full access to all pages & features
            </li>
            <li className="flex items-center gap-2">
              <Icon name="Check" size={14} className="text-emerald-600" />
              Unlimited AI insights & analytics
            </li>
            <li className="flex items-center gap-2">
              <Icon name="Check" size={14} className="text-emerald-600" />
              Ingredients, Cost Analytics & Compliance
            </li>
            <li className="flex items-center gap-2">
              <Icon name="Check" size={14} className="text-emerald-600" />
              Full Administration & Audit Logs
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2.5 bg-surface border border-border rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/main-dashboard')}
            className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-emerald-500 text-white rounded-lg text-sm font-medium hover:from-blue-600 hover:to-emerald-600 transition-all shadow-md"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureLockedPage;
